/**
 * @generated SignedSource<<f7d5da00d611be50d60fdb78a452c64c>>
 * @relayHash 159bf4bac8a1a80d105773b480997240
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20db2d1445a88500859c629d57fa4d931a97e30a19b4711f9fa608e2cde3f4ce

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ObjectCommentContainerPreloadObjectCommentsQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null> | null;
  first?: AGG$Long | null;
  includeCommentReactions?: boolean | null;
  includeConversationData?: boolean | null;
  pageId: string;
};
export type ObjectCommentContainerPreloadObjectCommentsQuery$data = {
  readonly comments: {
    readonly __typename: "PaginatedCommentList";
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly __typename: string;
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly permissionType: SitePermissionType | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
      readonly body: {
        readonly value: string;
      };
      readonly container: {
        readonly id: string | null;
      };
      readonly contentStatus: string;
      readonly contributors: ReadonlyArray<{
        readonly __typename: string;
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null> | null;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      };
      readonly location: {
        readonly __typename: string;
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineMarkerRef?: string | null;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineText?: string | null;
        readonly type: string;
      };
      readonly parentId: string | null;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly reactionsSummary?: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly contributors: ReadonlyArray<{
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null> | null;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly location: {
          readonly __typename: string;
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary?: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly version: {
          readonly by: {
            readonly __typename: string;
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly version: {
        readonly by: {
          readonly __typename: string;
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly type: string | null;
        } | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      };
    } | null> | null;
    readonly totalCount: number | null;
  } | null;
  readonly content?: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_contentPermission">;
    } | null> | null;
  } | null;
  readonly conversationCurrentUser?: {
    readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_currentUser">;
  } | null;
};
export type ObjectCommentContainerPreloadObjectCommentsQuery = {
  response: ObjectCommentContainerPreloadObjectCommentsQuery$data;
  variables: ObjectCommentContainerPreloadObjectCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "includeCommentReactions"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeConversationData"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v5 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "pageId"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v10 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v13 = {
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v10/*: any*/),
    (v12/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v17 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v18 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v15/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v20 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v22 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v23 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v24 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v25 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v27 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v28 = {
  "condition": "includeCommentReactions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        (v5/*: any*/)
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            }
          ]
        }
      ]
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "number"
},
v30 = {
  "kind": "ScalarField",
  "name": "when"
},
v31 = {
  "args": [
    {
      "kind": "Literal",
      "name": "confluenceCommentFilter",
      "value": {
        "commentState": "UNRESOLVED",
        "commentType": "FOOTER"
      }
    },
    {
      "kind": "Variable",
      "name": "contentStatus",
      "variableName": "contentStatus"
    },
    {
      "kind": "Literal",
      "name": "depth",
      "value": "ROOT"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": [
        "FOOTER"
      ]
    }
  ],
  "concreteType": "PaginatedCommentList",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/)
          ]
        },
        (v13/*: any*/),
        (v16/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "container",
          "plural": false,
          "selections": [
            (v6/*: any*/)
          ]
        },
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "replies",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v12/*: any*/),
                (v10/*: any*/)
              ]
            },
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "by",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    (v8/*: any*/)
                  ]
                },
                (v29/*: any*/),
                (v30/*: any*/)
              ]
            },
            (v13/*: any*/)
          ]
        },
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "by",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v11/*: any*/),
                (v8/*: any*/),
                (v12/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "friendlyWhen"
            },
            (v29/*: any*/),
            (v30/*: any*/)
          ]
        },
        (v28/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalCount"
    },
    (v7/*: any*/)
  ]
},
v32 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "archived",
      "draft"
    ]
  }
],
v33 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "selections": [
      (v31/*: any*/),
      {
        "condition": "includeConversationData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ViewPageConversation_currentUser"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "conversationCurrentUser"
          },
          {
            "args": (v32/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ViewPageConversation_contentPermission"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "selections": [
      (v31/*: any*/),
      {
        "condition": "includeConversationData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  },
                  (v14/*: any*/)
                ]
              }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          },
          {
            "args": (v32/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v33/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v33/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "159bf4bac8a1a80d105773b480997240",
    "id": "20db2d1445a88500859c629d57fa4d931a97e30a19b4711f9fa608e2cde3f4ce",
    "metadata": {},
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "operationKind": "query",
    "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long,$includeCommentReactions:Boolean=true,$includeConversationData:Boolean=false){...ViewPageConversation_currentUser@include(if:$includeConversationData)\n  content(id:$pageId,status:[\"current\",\"archived\",\"draft\"])@include(if:$includeConversationData){nodes{...ViewPageConversation_contentPermission,id}},comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}fragment ViewPageConversation_contentPermission on Content{id,type,operations{operation,targetType},space{id,operations{operation,targetType}},history{createdBy{__typename,...on KnownUser{accountId}}}}fragment ViewPageConversation_currentUser on Query{user:confluence_atlassianUser(current:true){id,displayName,photos{isPrimary,value}}}"
  }
};
})();

(node as any).hash = "57f51fc3d2e0ad8beb4f6f79bfab3086";

export default node;
